export const getLeftPosition = ({ windowWidth, contentElementWidth, triggerLeft, triggerRight, }) => {
    let leftPosition = triggerLeft;
    // when aligning content to the rightside of the trigger
    const leftOfContentIsOffscreen = triggerRight - contentElementWidth < 0;
    // when aligning content to the leftside of the trigger
    const rightOfContentIsOffscreen = windowWidth < triggerLeft + contentElementWidth;
    const leftOfTriggerIsOffscreen = triggerLeft < 0;
    const rightOfTriggerIsOfscreen = triggerRight > windowWidth;
    if (leftOfTriggerIsOffscreen || (leftOfContentIsOffscreen && rightOfContentIsOffscreen)) {
        leftPosition = 0;
    }
    else if (rightOfTriggerIsOfscreen) {
        // align content to right side of the window
        leftPosition = windowWidth - contentElementWidth;
    }
    else if (rightOfContentIsOffscreen) {
        // align content to left side of the window
        leftPosition = triggerRight - contentElementWidth;
    }
    return leftPosition;
};
//# sourceMappingURL=utils.js.map